import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function SuccessRouter() {
  const navigate = useNavigate();
  const [debug, setDebug] = useState(null);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);

    const rawAccessMode = params.get("accessMode") || "";
    const accessMode = rawAccessMode.trim().toUpperCase();

    const store = (params.get("store") || "").trim();
    const qs = store ? `?store=${encodeURIComponent(store)}` : "";

    // IA / Instant / Standard can all be treated as "new signup success" UI
    const instantModes = new Set(["IA", "INSTANT", "INSTANTACCESS", "STANDARD", "NEW", "SIGNUP"]);
    const renewalModes = new Set(["RENEW", "RENEWAL"]);

    if (instantModes.has(accessMode)) {
      navigate(`/success/instant${qs}`, { replace: true });
      return;
    }

    if (renewalModes.has(accessMode)) {
      navigate(`/success/renewal${qs}`, { replace: true });
      return;
    }

    // If missing/unknown, stop and show debug so you can see what Clover sent
    setDebug({
      fullUrl: window.location.href,
      accessModeRaw: rawAccessMode,
      accessModeParsed: accessMode,
      store
    });
  }, [navigate]);

  if (!debug) {
    return <div style={{ padding: 24, textAlign: "center" }}>Redirecting…</div>;
  }

  const storeQs = debug.store ? `?store=${encodeURIComponent(debug.store)}` : "";

  return (
    <div style={{ padding: 24, fontFamily: "system-ui", maxWidth: 720, margin: "0 auto" }}>
      <h2>Success route debug</h2>
      <p>
        I didn’t recognize the <b>accessMode</b> query param, so I did not redirect automatically.
      </p>
      <pre style={{ background: "#f5f5f5", padding: 12, borderRadius: 8, overflow: "auto" }}>
        {JSON.stringify(debug, null, 2)}
      </pre>
      <p>
        <a href={`/success/instant${storeQs}`}>Go to New Signup instructions</a>
        <br />
        <a href={`/success/renewal${storeQs}`}>Go to Renewal page</a>
      </p>
    </div>
  );
}
